// =====================================
//
//   CMS 
//   Author: Gray
//   createtime: 2016 / 11 / 07
//
// =====================================
window.InifECMobileApp.controller("CMSDesignController", ['$scope', '$state', '$stateParams', '$rootScope', 'CMSService',
    function($scope, $state, $stateParams, $rootScope, CMSService) {

        // --------------------------------
        // 上一頁
        // --------------------------------
        var goBack = function() {
            
        }

        var isActiveBlog = function() {

            switch($scope.state) {
                case window.STATES.BLOG_LIST:
                case window.STATES.BLOG_POST:
                    return true;
                default:
                    return false;
            }
        }

        var isActiveProject = function() {

            switch($scope.state) {
                case window.STATES.DESIGNER_LIST:
                case window.STATES.PROJECT_LIST:
                case window.STATES.PROJECT_POST:
                case window.STATES.DESIGNER:
                    return true;
                default:
                    return false;
            }
        }

        var isActiveResource = function() {
            
            switch($scope.state) {
                case window.STATES.RESOURCE_LIST:
                    return true;
                default:
                    return false;
            }
        }

        // --------------------------------
        // [private] 初始化
        // --------------------------------
        var init = function() {

        }

        //==========================
        //  Events
        //==========================
        $scope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {

            $scope.state = $state.current.name;

            if($scope.state == window.STATES.DESIGN_RSC) {
                $state.go(window.STATES.BLOG_LIST);
            }
        });

        //==========================
        //  Members
        //==========================
        $scope.state;

        //==========================
        //  Methods
        //==========================
        $scope.isActiveBlog = isActiveBlog;
        $scope.isActiveProject = isActiveProject;
        $scope.isActiveResource = isActiveResource;

        //==========================
        //  Init
        //==========================
        init();
    }
]);